export default __webpack_public_path__ + "static/7-4a0f718bbcff8214f4d2d0b1a6af8cca.webp";